import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const CompanyProfileSchema = z.object({
  company_name: z.string(),
  abn: z.string(),
  phone: z.string(),
  company_email: z.string(),
  address1: z.string(),
  address2: z.string(),
  city: z.string(),
  state: z.string(),
  post_code: z.string(),
  website: z.string(),
});

export type CompanyProfileForm = z.infer<typeof CompanyProfileSchema>;

export const CompanyProfileDefaultValues: CompanyProfileForm = {
  company_name: '',
  abn: '',
  phone: '',
  company_email: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  post_code: '',
  website: '',
};

export const useCompanyProfileForm = () => {
  const form = useForm({
    defaultValues: CompanyProfileDefaultValues,
    resolver: zodResolver(CompanyProfileSchema),
    reValidateMode: 'onBlur',
    disabled: false,
  });

  return form;
};
